import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {formObjectToRouteMap} from "../Navigation/Routes";
import {withRouter} from "react-router";
import $ from "jquery";
import {Link} from "react-router-dom";
import queryString from "query-string";
class Anchor extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            inOperation: true
        }
    }

    async componentDidMount() {
    }

    getUrlToPlaceholder = (commandID, commandParams, placeholderID) => {

        const menuItem = this.props.menu.Items.find(mi => mi.AppCommand && mi.AppCommand.ID === commandID);
        if (!menuItem)
            return "";
        const formName = menuItem.AppCommand.Param1;
        const target = formObjectToRouteMap[formName];
        if (!target)
            return "";

        const qs = queryString.stringify(commandParams);

        return "/" + target.link + (qs ? "?" + qs : "") + (placeholderID ? "#" + placeholderID : "");
    }

    render() {
        return (<>
            <Link to={this.getUrlToPlaceholder("CMD_LK_VACATION", null,"60")}>Test anchor</Link>
        </>)
    }
}

Anchor.propTypes = {
    dispatch: PropTypes.func.isRequired,
    menu: PropTypes.object
};

Anchor.defaultProps = {};

function mapStateToProps(state) {
    return {
        menu: state.appState.appParams.menu
    };
}

export default withRouter(connect(mapStateToProps)(Anchor));